'use client';

import { Mail, MessageCircle, Clock, Headphones } from 'lucide-react';
import { useTranslation } from '@/i18n/LanguageProvider';

export default function ContactPage() {
  const { t } = useTranslation();

  return (
    <div>
      <section className="bg-gradient-to-br from-primary-600 to-secondary-600 text-white py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{t('contact.title')}</h1>
          <p className="text-xl text-white/90">{t('contact.subtitle')}</p>
        </div>
      </section>

      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 dark:bg-gray-800 rounded-2xl p-8 hover:shadow-md transition-shadow">
              <div className="w-14 h-14 bg-primary-100 rounded-xl flex items-center justify-center mb-6"><Mail className="w-7 h-7 text-primary" /></div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">{t('contact.generalInquiries')}</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-4">{t('contact.generalDesc') || 'Preguntas sobre la plataforma, colaboraciones o prensa.'}</p>
              <a href="mailto:hola@iterogo.com" className="text-primary font-semibold hover:underline text-lg">hola@iterogo.com</a>
            </div>
            <div className="bg-gray-50 dark:bg-gray-800 rounded-2xl p-8 hover:shadow-md transition-shadow">
              <div className="w-14 h-14 bg-secondary-100 rounded-xl flex items-center justify-center mb-6"><MessageCircle className="w-7 h-7 text-secondary" /></div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">{t('contact.technicalSupport')}</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-4">{t('contact.supportDesc') || 'Problemas con la app, pagos, tours o tu cuenta.'}</p>
              <a href="mailto:soporte@iterogo.com" className="text-primary font-semibold hover:underline text-lg">soporte@iterogo.com</a>
            </div>
            <div className="bg-gray-50 dark:bg-gray-800 rounded-2xl p-8 hover:shadow-md transition-shadow">
              <div className="w-14 h-14 bg-accent-100 rounded-xl flex items-center justify-center mb-6"><Clock className="w-7 h-7 text-accent" /></div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">{t('contact.privacy') || 'Privacidad y datos'}</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-4">{t('contact.privacyDesc') || 'Ejercer derechos RGPD, solicitar eliminación de datos o consultas de privacidad.'}</p>
              <a href="mailto:privacidad@iterogo.com" className="text-primary font-semibold hover:underline text-lg">privacidad@iterogo.com</a>
            </div>
            <div className="bg-gray-50 dark:bg-gray-800 rounded-2xl p-8 hover:shadow-md transition-shadow">
              <div className="w-14 h-14 bg-primary-100 rounded-xl flex items-center justify-center mb-6"><Headphones className="w-7 h-7 text-primary" /></div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">{t('contact.becomeGuide') || '¿Quieres ser guía?'}</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-4">{t('contact.becomeGuideDesc') || 'Crea tours de audio, comparte tu ciudad y genera ingresos.'}</p>
              <a href="/guias" className="text-primary font-semibold hover:underline text-lg">{t('guias.startCreating')} →</a>
            </div>
          </div>

          <div className="mt-16 bg-primary-50 dark:bg-gray-800 rounded-2xl p-8 text-center">
            <Clock className="w-10 h-10 text-primary mx-auto mb-4" />
            <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">{t('contact.responseTime') || 'Tiempo de respuesta'}</h3>
            <p className="text-gray-600 dark:text-gray-300 max-w-lg mx-auto">{t('contact.responseDesc') || 'Respondemos en un plazo máximo de 48 horas laborables.'}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
